import { Globe, Loader2, Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { LANGUAGES, useLanguage } from "@/i18n/LanguageContext";

export const LanguageSwitcher = ({ variant = "light", testIdPrefix = "lang-switcher" }) => {
  const { lang, setLang, busy } = useLanguage();
  const current = LANGUAGES.find((l) => l.code === lang);
  const tone =
    variant === "dark"
      ? "text-white/80 hover:text-white bg-white/5 hover:bg-white/10 border-white/10"
      : "text-navy hover:text-teal hover:bg-slate-50 border-slate-200";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-2 text-sm font-semibold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-teal ${tone}`}
        aria-label={{ en: "Language", es: "Idioma", he: "בחירת שפה" }[lang]}
        data-no-translate
        data-testid={`${testIdPrefix}-trigger`}
      >
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Globe className="w-4 h-4" />}
        <span>{current.short}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[10rem]" data-no-translate>
        {LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onSelect={() => setLang(l.code)}
            className="flex items-center justify-between gap-3 cursor-pointer"
            dir={l.dir}
            data-testid={`${testIdPrefix}-option-${l.code}`}
          >
            <span>{l.label}</span>
            {l.code === lang && <Check className="w-4 h-4 text-teal" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
